<template>
  <v-stepper v-model="step">
    <v-stepper-items>
      <v-stepper-content step='1' class="pa-0">
        <v-card class="pa-4"  v-if="frentista">
          <v-layout justify-center aling-center row wrap fill-height>
            <v-card-title class="headline mb-1">{{ titulo }}</v-card-title>
            <v-card-text>
              <p style="text-align: center; color: red;">{{ texto }}</p>
              <v-form lazy-validation v-model="valid" ref="form">
                <v-layout column justify-center>
                  <v-flex>

                      <v-text-field
                        v-if="!isLogged"
                        :type="show ? 'text' : 'password'"
                        v-model="senha"
                        :append-icon="show ? 'visibility' : 'visibility_off'"
                        placeholder="****"
                        outline
                        counter="4"
                        single-line
                        hide-details
                        color="primary"
                        class="centered-input display-1 font-weight-black"
                        browser-autocomplete="off"
                        required
                        @click:append="show = !show"
                        :rules="[
                                v => {
                                    if (v) {
                                    return v.length && v.length == 4 || ''
                                    } else {
                                    return false
                                    }
                                }
                                ]"
                        mask="NNNN"
                      />

                      <template v-if="isLogged">
                        <div>
                          <v-text-field
                            v-model="login.email"
                            class="pb-3"
                            hide-details
                            box label="E-mail"
                            readonly
                          />

                          <v-text-field
                          v-model="login.password"
                            hide-details
                            class="pb-1"
                            box
                            label="Password"
                            :append-icon="show ? 'visibility' : 'visibility_off'"
                            :type="show ? 'text' : 'password'"
                            @click:append="show = !show"
                          />
                        </div>
                      </template>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-card-text>
          </v-layout>
          <v-card-actions>
            <v-btn round @click="voltar">{{cadastrar ? 'Voltar': 'Cancelar'}}</v-btn>
            <v-spacer></v-spacer>
            <v-btn round color="primary" @click="opcoes">Confirmar</v-btn>
          </v-card-actions>
          <v-layout justify-center aling-center row wrap fill-height v-if="cadastrar === false">
            <v-btn small round color="secondary" @click="cadastrar=true">cadastra PIN</v-btn>
          </v-layout>
        </v-card>
      </v-stepper-content>
      <v-stepper-content step='2' class="pa-0">
        <v-card class="pa-4">
          <v-layout justify-center aling-center row wrap fill-height>
            <v-card-title class="headline mb-1">Cadastre seu PIN</v-card-title>
            <v-card-text>
              <v-form lazy-validation v-model="valid" ref="form">
                <v-layout column justify-center>
                  <v-flex>

                      <v-text-field
                        :type="show ? 'text' : 'password'"
                        v-model="senha"
                        :append-icon="show ? 'visibility' : 'visibility_off'"
                        placeholder="****"
                        outline
                        counter="4"
                        single-line
                        hide-details
                        color="primary"
                        class="centered-input display-1 font-weight-black"
                        browser-autocomplete="off"
                        required
                        @click:append="show = !show"
                        :rules="[
                                v => {
                                    if (v) {
                                    return v.length && v.length == 4 || ''
                                    } else {
                                    return false
                                    }
                                }
                                ]"
                        mask="NNNN"
                      />
                  </v-flex>
                </v-layout>
              </v-form>
            </v-card-text>
          </v-layout>
          <v-card-actions>
            <v-btn round @click="voltar">Voltar</v-btn>
            <v-spacer></v-spacer>
            <v-btn round color="primary" @click="opcoes">Cadastrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>

<script>
export default {
  props: ['frentistaSelecionado', 'tipoAbastecimento'],
  data () {
    return {
      isLogged: false,
      login: { email: '', password: '' },
      step: 1,
      titulo: 'Inserir PIN',
      texto: '',
      cadastrar: false,
      show: false,
      senha: null,
      valid: false,
      passwordVisible: false,
      eyeSvg: 'eye-closed',
      fieldType: 'text'
    }
  },
  mounted () {
    this.fieldType = this.type
  },
  computed: {
    loading () {
      return this.$store.getters.loading
    },
    frentista () {
      return this.$store.getters.frentista
    },
    posto () {
      return this.$store.getters.posto
    }
  },
  watch: {
    type (val) {
      this.fieldType = val
    },
    cadastrar (val) {
      if (val) {
        this.senha = ''
        if (this.frentista.id_frentista === this.frentistaSelecionado.id_frentista) {
          this.isLogged = true
          this.titulo = 'Insira sua senha'
          this.login.email = this.frentista.pessoa.email
        } else {
          this.texto = '*Requer PIN do gerente'
          this.titulo = 'Inserir PIN do gerente'
        }
      }
    }
  },
  methods: {
    obfuscateToggle () {
      if (this.eyeSvg === 'eye-closed') {
        this.eyeSvg = 'eye'
      } else this.eyeSvg = 'eye-closed'

      if (this.fieldType === 'password') {
        this.fieldType = 'text'
      } else this.fieldType = 'password'
    },
    voltar () {
      if (this.cadastrar && this.step === 1) {
        this.limparCampos()
      } else if (this.step === 2) {
        this.limparCampos()
        this.step = 1
      } else {
        this.fechar()
      }
    },
    opcoes () {
      switch (this.step) {
        case 1:
          if (this.cadastrar) {
            if (this.isLogged) {
              this.fazerLogin()
            } else {
              this.autenticar(this.frentista)
            }
          } else {
            this.autenticar(this.frentistaSelecionado)
          }
          break
        case 2:
          this.editarFrentista()
      }
    },
    fazerLogin () {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('signUserIn', { email: this.login.email, password: this.login.password }).then(value => {
          if (value) {
            this.step = 2
          }
        })
      }
    },
    autenticar (frentista) {
      if (this.$refs.form.validate() && this.senha && this.senha !== '') {
        this.$store.dispatch('autenticarPin', { cnpj: this.posto.cnpj, pin: this.senha, id: frentista.id_frentista, tipoAbastecimento: this.tipoAbastecimento }).then(() => {
          if (this.cadastrar) {
            this.limparCampos()
            this.step = 2
            this.titulo = 'Inserir PIN'
            this.texto = ''
          } else {
            this.$emit('autenticado')
            this.fechar()
          }
        })
      }
    },
    editarFrentista () {
      if (this.$refs.form.validate() && this.senha && this.senha !== '') {
        this.$store.dispatch('editarFrentista', {
          pin: this.senha,
          id: this.frentistaSelecionado ? this.frentistaSelecionado.id_frentista : null,
          frentista: this.frentista.id_frentista
        }).then(value => {
          if (value === 200) {
            this.step = 1
            this.limparCampos()
            this.cadastrar = false
          }
        })
      }
    },
    limparCampos () {
      this.titulo = 'Inserir PIN'
      this.login.email = ''
      this.login.password = ''
      this.senha = ''
      this.texto = ''
      this.cadastrar = false
      this.isLogged = false
      this.show = false
    },
    fechar () {
      this.step = 1
      this.limparCampos()
      this.$emit('fechar')
    }
  }
}
</script>
